<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
      Process
    </li>
  
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Process </strong>
      </span>
      <span style="float: right">
  
        <!-- <button class="btn btn-sm btn-primary" type="button" data-toggle="modal" data-target="#processDialog" (click)="showAddPopUp()"><i class="fa fa-plus"></i>Add Process</button> -->
  
        <button class="btn btn-sm btn-primary" type="button" (click)="addProcessChange()" [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
          <i class="fa fa-plus"></i>&nbsp;Add Process</button>
  
        <!-- &nbsp; &nbsp; &nbsp;
            <button type="button" class="btn btn-sm btn-primary" [routerLink]="['/tasks/addTask']" >
              <i class="fa fa-plus"></i>Add Task to Process
            </button> &nbsp; &nbsp; &nbsp;
            <button type="button" class="btn btn-sm btn-primary" [routerLink]="['/process/activate']">
              <i class="fa fa-check"></i>Activate Process
            </button> &nbsp; &nbsp; &nbsp;
            <button type="button" class="btn btn-sm btn-primary pull-right" [routerLink]="['/process/tasks']">
              Process Tasks
            </button> -->
      </span>
    </div>
  
    <section class="card search-box">
        <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
        <div class="card-block collapse" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-md-12">
            <div class="margin-bottom-50">
  
              <div class="modal-body">
  
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <div class="md-radio md-radio-inline" style="display: inline-block">
                        <input id="IsPreDefined" type="radio" style="position:absolute" name="IsPredefinedorUserdefined" [(ngModel)]="SearchprocessUserdefinedorPredefinedModel"
                          [ngModelOptions]="{standalone: true}" value="Predefined" (click)="CheckProcessType('Predefined')" class="form-check-input">
                        <label for="IsPreDefined" style="padding: 0 29px 0px 0px">Pre defined</label>
                      </div>
                      <div class="md-radio md-radio-inline" style="display: inline-block">
                        <input id="IsUserDefined" type="radio" style="position:absolute" name="IsPredefinedorUserdefined" [(ngModel)]="SearchprocessUserdefinedorPredefinedModel"
                          [ngModelOptions]="{standalone: true}" value="Userdefined" (click)="CheckProcessType('Userdefined')"
                          class="form-check-input">
                        <label for="IsUserDefined">User defined</label>
                      </div>
                    </div>
                  </div>
  
  
                  <div class="col-md-2">
                    <div class="input-group">
  
                      <button type="button" [disabled]="response" class="btn btn-sm btn-default" (click)="showAllProcesses()" title="refresh">
                        <i class="fa fa-refresh"></i>&nbsp;Clear
                      </button>
                    </div>
                  </div>
  
                  <div class="col-md-3">
                  </div>
  
                </div>
              </div>
  
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                id="processTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>
                      Process Name
                      <i class="fa fa-info-circle" 
                         data-toggle="tooltip" 
                         data-placement="top" 
                         title="The title of the process, such as AGM, EGM, or E-Voting. Each process can contain multiple tasks"
                         style="margin-left: 5px; color: #5bc0de; cursor: help;"></i>
                    </th>
                    <th class="process-list-column">
                      Global/Company Specific
                      <i class="fa fa-info-circle" 
                         data-toggle="tooltip" 
                         data-placement="top" 
                         title="Indicates whether the process is common across all companies (Global) or defined only for this company (Company Specific)"
                         style="margin-left: 5px; color: #5bc0de; cursor: help;"></i>
                    </th>
                    <th class="process-list-column">
                      Meeting Type
                      <i class="fa fa-info-circle" 
                         data-toggle="tooltip" 
                         data-placement="top" 
                         title="Select the meeting type (e.g., Board Meeting, Committee Meeting) to link this process with that meeting. If set to N/A, the process will not appear in meetings but can still be selected when creating an agenda"
                         style="margin-left: 5px; color: #5bc0de; cursor: help;"></i>
                    </th>
                    <th class="process-list-action">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let process of processes; let count=index">
                    <td tabindex="1" style="white-space: normal !important;">{{process.ProcessName }}</td>
                    <td class="process-list-column">
                      <span *ngIf="process.IsGlobal">Global</span>
                      <span *ngIf="!process.IsGlobal">Company Specific</span>
                    </td>
                    <td class="process-list-column">
                      <span *ngIf="process.ProcessDataList.length > 0">{{process.ProcessDataList[0].MeetingType}}</span>
                      <span *ngIf="process.MeetingTypeId==null">N/A</span>
                    </td>
                    <td class="process-list-action">
                      <button type="button" 
                              class="btn-sm btn btn-warning" 
                              (click)="loadProcessToEdit(process._id)" 
                              [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}"
                              data-toggle="tooltip" 
                              data-placement="top" 
                              title="Update details of this process, such as its name, tasks, or meeting type">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                      <button type="button" 
                              class="btn-sm btn btn-danger" 
                              (click)="deleteConfirmation(process._id)" 
                              [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}"
                              data-toggle="tooltip" 
                              data-placement="top" 
                              title="Remove this process permanently from the library. Use with caution as it cannot be undone">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
  
            <!-- <div class="modal fade modal-size-large" id="processDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <form [formGroup]="processMasterForm" class="well" (keydown)="keyDownEnterFunction($event)">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">Process Master</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label">Global / Company</label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <div class="md-radio md-radio-inline">
                              <input id="IsGlobalYes" type="radio" [formControl]="processMasterForm.controls['IsGlobal']" style="position:absolute" name="IsGlobal"
                                value="Global" class="form-check-input">
                              <label for="IsGlobalYes">Global</label>
                            </div>
                            <div class="md-radio md-radio-inline">
                              <input id="IsGlobalNo" type="radio" [formControl]="processMasterForm.controls['IsGlobal']" style="position:absolute" name="IsGlobal"
                                value="Company" class="form-check-input">
                              <label for="IsGlobalNo">Company</label>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label" for="l0">Process Name
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
  
                            <input [formControl]="processMasterForm.controls['ProcessName']" class="form-control" id="processName">
                            <div *ngIf="processMasterForm.controls['ProcessName'].hasError('required') && processMasterForm.controls['ProcessName'].touched"
                              class="form-control-error-custom">
                              Process name is required.
                            </div>
                            <div *ngIf="processMasterForm.controls['ProcessName'].hasError('pattern') && processMasterForm.controls['ProcessName'].touched"
                              class="form-control-error-custom">
                              Please enter a valid Process name.
                            </div>
                          </div>
                        </div>
  
                      </div>
  
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-1">
                              <div class="form-group">
                                <div class="md-checkbox">
                                  <!--<input type="checkbox" id="1" [ngModel]="filter" (ngModelChange)="onFilterChange($event)">-->
            <!-- <input id="IsMeetingSpecific" #meetingSpecific type="checkbox" [(ngModel)]="isMeetingTask" [ngModelOptions]="{standalone: true}"
                                    (change)="0" checked>
                                  <label for="IsMeetingSpecific"></label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-11">
  
                              <label class="form-control-label">Select in case of Meeting Specific Process (if not selected then this process will not be shown
                                in meeting add screen)</label>
                            </div>
  
                          </div>
                        </div>
                      </div>
  
                      <div class="row" *ngIf="meetingSpecific.checked">
                        <div class="col-md-3">
                          <label class="form-control-label" for="l0">Meeting Type
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <select [formControl]="processMasterForm.controls['meetingtypeId']" class="form-control select" [(ngModel)]="meetingtypeId">
                              <option value="0"> None </option>
                              <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                                {{meetingType.MeetingType}}
                              </option>
                            </select>
  
                            <div *ngIf='meetingSpecific.checked && meetingtypeId=="0"' class="form-control-error-custom">
                              Meeting Type is required.
                            </div>
  
                          </div>
                        </div>
                      </div>
  
  
                    
  
                      <div class="card-block datatable-card-block">
                        <div class="row">
                         <div class="col-md-12">
                          <div class="margin-bottom-50">
                            <div class="table-responsive">
                              <table datatable [dtOptions]="dtOptionsforProcessTasks" [dtTrigger]="dtTriggerforProcessTasks" class="table table-hover compact cell-border nowrap stripe"
                                id="processtaskTable" style="cursor: pointer;">
                                <thead>
                                  <tr>
                                    <th class="process-list-column">Task Name </th>
                                    <th>Task Description </th>
                                    <th class="process-list-column">Group Name</th>
                                    <th class="process-list-column">Process Name</th>
                                    <th class="process-list-action">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let processtask of processtasklist; let count=index">
                                    <td class="process-list-column">{{processtask.ProcessTasksData.TaskName }}</td>
                                    <td tabindex="2">{{processtask.ProcessTasksData.TaskDescription }}</td>
                                    <td class="process-list-column">{{processtask.ProcessTasksData.GroupName }}</td>
                                    <td class="process-list-column">{{processtask.ProcessTasksData.ProcessName }}</td>
                                    <td class="process-list-action">
                    
                                      <button type="button" class="btn-sm btn btn-warning" (click)="loadProcessTaskToEdit(processtask.ProcessTasksData.ID,processtask.ProcessTasksData.processID)">
                                            <span class="fa fa-pencil"></span>
                                        </button>&nbsp;&nbsp;&nbsp;
                                      <button type="button" class="btn-sm btn btn-danger" (click)="deleteProcessTaskConfirmation(processtask._id)">
                                            <span class="icmn-bin"></span>
                                      </button>
                    
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                         </div>
                        </div>
                      </div>
  
  
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveProcess" type="button" class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || meetingSpecific.checked && meetingtypeId=="0"'
                        (click)="addProcess()">
                        <i class="fa fa-save"></i>Save</button>
                      <button id="btnupdateProcess" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || meetingSpecific.checked && meetingtypeId=="0"'
                        (click)="editProcess()">
                        <i class="fa fa-save"></i>Update</button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>Close</button>
                    </div>
                  </div>
                </form>
              </div>
            </div> -->
  
  
  
            <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete the Process?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="deleteProcess()">
                      <i class="fa fa-check"></i>&nbsp;Yes</button>
                  </div>
                </div>
              </div>
            </div>
  
  
            <!-- <div class="modal fade" id="confirmationdeleteProcessTask" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete"><i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete this task?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary" (click)="deleteTaskProcess()"><i class="fa fa-check"></i>Yes</button>
                    <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal"><i class="fa fa-times"></i>No</button>
                  </div>
                </div>
              </div>
            </div> -->
  
          </div>
        </div>
      </div>
    </div>
  
  
  </section>
  <app-alert></app-alert>